// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"135":"discussion-forum","164":"pdf-lesson","308":"quiz","913":"watch-lesson","929":"my-player"}[chunkId] + ".css";
};